import React from "react";
import GraphViewer from "./GraphViewer";

export const MATURA_FUNCTION_GRAPH_SIZE = 350;
export const MATURA_FUNCTION_GRAPH_COLOR = "#ff9800";
export const MATURA_FUNCTION_GRAPH_RANGE = [-6, 6];

function withPointDefaults(points, color) {
  return Object.fromEntries(
    Object.entries(points || {}).map(([key, point]) => [
      key,
      {
        ...point,
        color: point.color || color,
        textColor: point.textColor || point.color || color,
      },
    ])
  );
}

function withLineDefaults(items, color) {
  return (items || []).map((item) => {
    const normalized = typeof item === "string" ? { expr: item } : item;
    return {
      ...normalized,
      color: normalized.color || color,
      markerColor: normalized.markerColor || normalized.color || color,
      width: normalized.width || 4,
    };
  });
}

function withSegmentDefaults(segments, color) {
  return withLineDefaults(segments, color).map((segment) => ({
    ...segment,
    showMarkers: segment.showMarkers ?? false,
  }));
}

export default function MaturaFunctionGraph({
  points = {},
  segments = [],
  curves = [],
  equations = [],
  color = MATURA_FUNCTION_GRAPH_COLOR,
  xRange = MATURA_FUNCTION_GRAPH_RANGE,
  yRange = MATURA_FUNCTION_GRAPH_RANGE,
  ...viewerProps
}) {
  return (
    <div
      style={{
        width: `min(100%, ${MATURA_FUNCTION_GRAPH_SIZE}px)`,
        margin: "10px auto 20px",
      }}
    >
      <GraphViewer
        {...viewerProps}
        width={MATURA_FUNCTION_GRAPH_SIZE}
        height={MATURA_FUNCTION_GRAPH_SIZE}
        points={withPointDefaults(points, color)}
        segments={withSegmentDefaults(segments, color)}
        curves={withLineDefaults(curves, color)}
        equations={withLineDefaults(equations, color)}
        xRange={xRange}
        yRange={yRange}
      />
    </div>
  );
}
